module.exports = __webpack_public_path__ + "5ef6101acc352cb69a46c014f520098b.png";


//////////////////
// WEBPACK FOOTER
// ./app/pages/HomePage2/NationalProduction/production-map.png
// module id = 860
// module chunks = 1